import { defineStore } from 'pinia';
import { doc, getDoc } from 'firebase/firestore';
import { useFirestore } from 'vuefire';

export const useUserStore = defineStore('user', {
  state: () => ({
    user: null,
  }),
  actions: {
    async fetchUserFromFirestore() {
      if (!this.user || !this.user.userId) {
        console.warn('No user logged in or user ID not available');
        return null;
      }
      
      const db = await useFirestore();
      const userDocRef = doc(db, 'users/' + this.user.userId);
      const userDoc = await getDoc(userDocRef);
      
      if (userDoc.exists()) {
        return userDoc.data();
      } else {
        console.warn(`User document not found for userId: ${this.user.userId}`);
        return null;
      }
    },
    setUser(user) {
      // If user is verified keep it verified
      if (this.user && this.user.verification) {
        user.verification = this.user.verification;
      }
      
      this.user = user;
    },
    clearUser() {
      this.user = null;
    },
  },
});